// hooks and utilities
import useDemand, { useDefaultDemand } from "hooks/useDemand";
import { useTranslateFunction } from "lang/Translate";
import { routerOptions } from "hooks/useRedirect";
import { useTabIdNew } from "hooks/useTabId";
import { useHub } from "hooks/useAirport";

// components
import SideWindowTab from "../SideWindowTab";

// styles
import "./AirportPopup.scoped.scss";
import "./DemandTab.scoped.scss";
import BallPulseLoader from "components/common/BallPulseLoader/BallPulseLoader";

function DemandTab() {
	const airportId = useTabIdNew("airport", { ...routerOptions.get("s"), isNumber: true });
	const hub = useHub();
	const [, currentDemand] = useDemand(hub.id, airportId);
	const defaultDemand = useDefaultDemand(hub.id, airportId);

	const translate = useTranslateFunction("SideWindow->AirportPopup");

	return (
		<SideWindowTab text={translate("CURRENT_DEMAND")} Icon={<i className="fas fa-chart-simple" />}>
			<p className="info">
				{translate("HUB_INFO").split("%")[0]} <b>{hub.iata_code || hub.ident}</b>{" "}
				{translate("HUB_INFO").split("%")[1]}
			</p>

			<div className="item">
				<div className="heading">{translate("ECONOMY")}</div>
				{/* TODO: use BallPulseLoader from agm-ui */}
				<div className="content">
					{currentDemand && defaultDemand ? (
						<p>
							{currentDemand[0]} / {defaultDemand[0]}
						</p>
					) : (
						<BallPulseLoader color="#14273e" />
					)}
				</div>
			</div>
			<div className="item">
				<div className="heading">{translate("PREMIUM")}</div>
				<div className="content">
					{currentDemand && defaultDemand ? (
						<p>
							{currentDemand[1]} / {defaultDemand[1]}
						</p>
					) : (
						<BallPulseLoader color="#14273e" />
					)}
				</div>
			</div>
			<div className="item">
				<div className="heading">{translate("BUSINESS")}</div>
				<div className="content">
					{currentDemand && defaultDemand ? (
						<p>
							{currentDemand[2]} / {defaultDemand[2]}
						</p>
					) : (
						<BallPulseLoader color="#14273e" />
					)}
				</div>
			</div>
			<div className="item">
				<div className="heading">{translate("FIRST")}</div>
				<div className="content">
					{currentDemand && defaultDemand ? (
						<p>
							{currentDemand[3]} / {defaultDemand[3]}
						</p>
					) : (
						<BallPulseLoader color="#14273e" />
					)}
				</div>
			</div>
		</SideWindowTab>
	);
}

export default DemandTab;
